import axios from 'axios';
import * as loadingActions from './loading.js';

export function loadHeader() {
  return(dispatch, getState) => {
    dispatch(loadingActions.loadingData(getState().loading));
    axios.get('https://api.qiydaarpratt.com/api/v1/blocks').then((response)=>{
      dispatch(loadHeaderSuccess(response.data));
      dispatch(loadingActions.doneLoadingData(getState().loading));
    }).catch(error => dispatch(loadHeaderError(error)));
  }
}

export const loadHeaderStart = () => ({
  type: 'LOAD_HEADER_START'
});

export const loadHeaderSuccess = header_data => ({
  type: 'LOAD_HEADER_SUCCESS',
  payload: header_data
});

export const loadHeaderError = error => ({
  type: 'LOAD_HEADER_ERROR',
  payload: error
});



// WEBPACK FOOTER //
// ./src/actions/header.js